'use client';

import { createBrowserClient } from '@supabase/ssr';
import type { SupabaseClient } from '@supabase/supabase-js';

import { readSupabaseConfig } from '@/lib/env';
import type { Database } from './types';
import { createMockSupabaseClient, isCI } from './mock';

let browserClient: SupabaseClient<Database> | null = null;

export function getSupabaseBrowserClient() {
  if (!browserClient) {
    // Use mock client in CI/test environments
    if (isCI()) {
      browserClient = createMockSupabaseClient();
      return browserClient;
    }

    const result = readSupabaseConfig();

    if (!result.config) {
      throw new Error(`Supabase is not configured. Missing: ${result.missing.join(', ')}`);
    }

    browserClient = createBrowserClient<Database>(result.config.url, result.config.publishableKey);
  }

  return browserClient;
}
